module.exports = __webpack_public_path__ + "img/Machine6.fd14d8fa.svg";